import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import {ApiService} from './api.service'

@Injectable()
export class IsLoggedGuard implements CanActivate {

	constructor(private api:ApiService, private route: ActivatedRoute){}
	canActivate(next: ActivatedRouteSnapshot,state: RouterStateSnapshot){

		this.api.fromLink = state.url;

		console.log(this.api.fromLink);

		if(this.api.user != undefined || (this.api.pro === false && this.api.games)){
			return true;
		}else{
			this.api.fromGuard = true;
			if(this.api.fromLink == '/commande/fast')
              localStorage.setItem('EspaceProBlackrockPage','/commande/fast');
			this.api.goTo('login');
			return false;
		}
	}
}

@Injectable()
export class IsProGuard implements CanActivate {

	constructor(private api:ApiService, private route: ActivatedRoute){}
	canActivate(next: ActivatedRouteSnapshot,state: RouterStateSnapshot){
		if(this.api.pro === true){
			return true;
		}else{
			localStorage.removeItem("EspaceProBlackrockPage");
			this.api.fromGuard = true;
			this.api.goTo('login');
			return false;
		}
	}
}